import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=7d904c58&"
import script from "./ProductList.vue?vue&type=script&lang=js&"
export * from "./ProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusTitle: require('/~/src/modules/opus/components/Title.vue').default,OpusLink: require('/~/src/modules/opus/components/Link.vue').default,OpusButton: require('/~/src/modules/opus/components/Form/Button.vue').default,ProductCard: require('/~/src/modules/opus-ecom/components/ProductCard.vue').default,Slider: require('/~/src/components/Slider.vue').default})
